import React from 'react';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../../useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs, DEFAULT_CONFIG } from './listConfig';

const ListFeatureSegments: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { requestGetFeatureSegmentsList } = useService();

	return (
		<DataList
			fetchData={requestGetFeatureSegmentsList}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			defaults={DEFAULT_CONFIG}
			disablePagination={false}
			disablePaginationSelect={false}
			entity={LIST_ENTITY_NAMES.USER_SEGMENT}
			initialSortDirection='ASC'
			initialSortIndex={1}
			searchable
			filterable
			fullDataSearch
		/>
	);
};

export default ListFeatureSegments;
